<div mat-dialog-title class="dialog-header justify-content-between">
    <div class="mat-d">
        <ng-content select="[dialog-title]"></ng-content>
    </div>
    <span *ngIf="!config.disabledCloseBtn" class="close" (click)="close()">
        <i class="fa fa-close"></i>
    </span>
</div>

<div mat-dialog-content class="mx-0">
    <ng-container *ngIf="!config.process.finished; else dialogProcessFinished">
        <ng-container *ngIf="!config.process.loading; else loaderContainer">
            <ng-content select="[dialog-process-in-progress]"></ng-content>
        </ng-container>
        <ng-template #loaderContainer>
            <div class="preloader-wrapper">
                <app-preloader></app-preloader>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #dialogProcessFinished>
        <div class="mb-4 d-flex justify-content-center">
            <ng-container *ngIf="!config.process.failed; else failedProcessContainer">
                <i class="fa fa-2x fa-check-circle text-accent d-flex align-items-center"></i>
                <span class="ml-2 text-justify" [innerHTML]="config.process.succeedMessage|sanitizeHtml"></span>
            </ng-container>
            <ng-template #failedProcessContainer>
                <i class="fa fa-2x fa-times-circle text-danger d-flex align-items-center"></i>
                <span class="ml-2 text-justify" [innerHTML]="config.process.failedMessage|sanitizeHtml"></span>
            </ng-template>
        </div>
        <div class="row justify-content-center">
            <button class="btn btn-primary" (click)="sendActionCode(actionsEnum.ProcessFinished)">Ok</button>
        </div>
    </ng-template>
</div>

<div *ngIf="config && (config.buttons.length > 0) && !config.buttonsHidden" mat-dialog-actions
     class="justify-content-end px-4 mt-3 py-4">
    <ng-container *ngFor="let button of config.buttons">
        <ng-container *ngIf="!button.hidden" [ngSwitch]="button.type">
            <button
                *ngSwitchCase="buttonTypesEnum.Cancel"

                (click)="sendActionCode(actionsEnum.Decline, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-danger mr-2"
            >Cancel
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Delete"

                (click)="sendActionCode(actionsEnum.Decline, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-danger mr-2"
            >Delete
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Remove"

                (click)="sendActionCode(actionsEnum.Decline, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Remove
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Ok"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Ok
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Submit"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Submit
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Apply"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Apply
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Create"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Create
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Save"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >Save
            </button>
            <button
                *ngSwitchCase="buttonTypesEnum.Confirm"

                (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                [disabled]="button.disabled || config.buttonsDisabled"

                class="btn btn-primary mr-2"
            >{{!button.customText ? 'Confirm' : button.customText}}
            </button>
            <button
                    *ngSwitchCase="buttonTypesEnum.Update"

                    (click)="sendActionCode(actionsEnum.Confirm, button.disabled)"

                    [disabled]="button.disabled || config.buttonsDisabled"

                    class="btn btn-primary mr-2"
            >Update
            </button>
        </ng-container>
    </ng-container>
</div>
